import React from 'react';
import { CarouselProvider, Slider, Slide} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import image1 from '../../Images/image 1.jpg';
import image2 from '../../Images/image 2.jpg';
import image3 from '../../Images/image 3.jpg';
import image4 from '../../Images/referandearn.png'
import './Customerlogin.css'; 
 
const Corousal = () => {
  const OfferList = [image1, image2, image3];
 
  return (
    <div style={{ width: '100%',height:'100%',marginLeft:'1vw'}}> 
      <CarouselProvider
        naturalSlideWidth={16}  // Aspect ratio width (16:9 in this case)
        naturalSlideHeight={9}  // Aspect ratio height
        totalSlides={OfferList.length}
        isPlaying={true}
        interval={3000}
        style={{ height: '100%' }} 
      >
        <Slider style={{ height: '100%' }}> 
          {OfferList.length > 0 && OfferList.map((offer, index) => (
            <Slide index={index} key={index+1}>
              <img 
                src={offer} 
                alt={`Slide ${index + 1}`} 
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'fill', 
                  borderRadius: '10px',
                }} 
              />
            </Slide>
          ))}
        </Slider>
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          {/* <DotGroup className="custom-dot-group" /> */}
        </div>
      </CarouselProvider>
    </div>
  );
}
 
export default Corousal;
 